/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
		<Path d="M10 6H18V14H16.5V8.5L7 18L6 17L15.5 7.5H10V6Z" />
	</SVG>
);
